module.exports = __webpack_public_path__ + "img/usage-6.16f546cc.png";